import {
  Users,
  Scale,
  ShieldCheck,
  FolderLock,
  Camera,
  MessageSquare,
  Share2,
  AlertTriangle,
  Lock,
  Workflow,
} from "lucide-react";
import { Reveal, SectionHead } from "@/components/Reveal";

const topics = [
  {
    icon: Users,
    title: "Personenbezogene Daten verstehen",
    text: "Welche Daten in Einsatzorganisationen besonders relevant sind und warum.",
  },
  {
    icon: Scale,
    title: "Datenschutz-Grundprinzipien",
    text: "Welche datenschutzrechtlichen Grundprinzipien im Alltag berücksichtigt werden müssen.",
  },
  {
    icon: ShieldCheck,
    title: "Verantwortlichkeiten",
    text: "Wie Verantwortlichkeiten innerhalb einer Organisation einzuordnen sind.",
  },
  {
    icon: FolderLock,
    title: "Einsatz-, Mitglieder- und Kontaktdaten",
    text: "Worauf beim täglichen Umgang mit diesen Informationen zu achten ist.",
  },
  {
    icon: Camera,
    title: "Fotos & Videos",
    text: "Welche datenschutzrechtlichen Fragen bei Bild- und Videoaufnahmen entstehen können.",
  },
  {
    icon: MessageSquare,
    title: "Messenger & digitale Dienste",
    text: "Welche Risiken Messenger, digitale Werkzeuge und Kommunikationsplattformen mit sich bringen können.",
  },
  {
    icon: Share2,
    title: "Social Media",
    text: "Worauf Organisationen bei Veröffentlichungen und sozialen Netzwerken achten sollten.",
  },
  {
    icon: AlertTriangle,
    title: "Datenschutzverletzungen",
    text: "Wie mögliche Datenschutzverletzungen erkannt und richtig eingeordnet werden.",
  },
  {
    icon: Lock,
    title: "Technische und organisatorische Maßnahmen",
    text: "Warum technische und organisatorische Maßnahmen für wirksamen Datenschutz entscheidend sind.",
  },
  {
    icon: Workflow,
    title: "Datenschutz in Abläufe integrieren",
    text: "Wie Datenschutz Schritt für Schritt Bestandteil bestehender Prozesse werden kann.",
  },
];

const Topics = () => (
  <section
    id="inhalte"
    data-testid="topics-section"
    className="py-24 sm:py-32"
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <SectionHead
        overline="Inhalte"
        title="Das erwartet Sie"
        sub="Zehn Themenfelder – vom Umgang mit personenbezogenen Daten bis zur Integration von Datenschutz in bestehende Abläufe Ihrer Organisation."
      />

      <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {topics.map((t, i) => (
          <Reveal key={t.title} delay={(i % 3) * 0.1}>
            <article
              data-testid={`topic-card-${i + 1}`}
              className="card-glow group h-full rounded-xl border border-white/8 bg-navy-800/60 p-7 transition-[transform,box-shadow,border-color] duration-300 hover:-translate-y-1 hover:border-blau/40"
            >
              <div className="flex h-11 w-11 items-center justify-center rounded-lg border border-blau/30 bg-blau/10 text-blau-glow transition-colors duration-300 group-hover:bg-blau group-hover:text-white">
                <t.icon size={20} strokeWidth={1.8} aria-hidden="true" />
              </div>
              <h3 className="mt-5 font-display text-lg font-bold text-white leading-snug">
                {t.title}
              </h3>
              <p className="mt-3 text-sm text-gray-400 leading-relaxed">
                {t.text}
              </p>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Topics;
